import { PURL_REGEXP_ROUTER } from 'config/core';
import { convertLocationToPath } from 'helpers/converters';
import { wrap } from 'helpers/helpers';
import { pathFormValid } from 'helpers/helpers';
import { getPageLink } from 'helpers/resources';
import PropTypes from 'prop-types';
import React, { lazy } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import routes from 'routes/routes';

const propTypes = {
  location: PropTypes.object.isRequired
};

const RouteContainers = {
  AuthPageContainer: lazy(() =>
    import('components/containers/auth-page-container/AuthPageContainer')
  ),
  MyAccountPageContainer: lazy(() =>
    import(
      'components/containers/my-account-page-container/MyAccountPageContainer'
    )
  )
};

const getPagesRoutes = (routesCofig, location) => {
  const routes = routesCofig.map(
    ({
      from,
      to,
      toId,
      query,
      exact,
      container,
      component,
      path,
      ...routeArgs
    }) => {
      if (from) {
        const _location = { ...location };
        let pathname = toId ? getPageLink(toId) : to;
        if (query) {
          if (_location.search && /^\?/.test(_location.search)) {
            _location.search = `${_location.search}&${query}`;
          } else {
            _location.search = `?${query}`;
          }
        }
        return (
          <Redirect
            key={from}
            {...{ exact, from, to: { ..._location, pathname } }}
          />
        );
      } else {
        const PageComponent = lazy(() => import(`./${component}`));
        const PageContainer =
          container && RouteContainers[container]
            ? RouteContainers[container]
            : null;
        return (
          <Route
            key={path}
            {...{ exact, path }}
            render={routeProps =>
              wrap(
                PageContainer,
                <PageComponent {...routeProps} {...routeArgs} />
              )
            }
          />
        );
      }
    }
  );
  return routes;
};

const renderRoutes = (routesCofig, location) => {
  const routes = getPagesRoutes(routesCofig, location);

  routes.push(
    <Route
      key="purls"
      path={PURL_REGEXP_ROUTER}
      exact
      component={lazy(() => import('./components/pages/purls/Purls'))}
    />
  );

  routes.push(
    <Route
      key="404"
      component={lazy(() =>
        import('./components/pages/not-found-page/NotFoundPage')
      )}
    />
  );

  return routes;
};

const RoutesList = ({ location }) => {
  return !pathFormValid(location.pathname) ? (
    /* force trailing slash */
    <Redirect
      to={convertLocationToPath(location, {
        pathname: `${location.pathname}/`
      })}
    />
  ) : (
    /* all routes */
    <Switch>{renderRoutes(routes, location)}</Switch>
  );
};

RoutesList.propTypes = propTypes;

export default RoutesList;
